import { render, staticRenderFns } from "./unit_rating.vue?vue&type=template&id=71c9feb6&scoped=true&"
import script from "./unit_rating.vue?vue&type=script&lang=js&"
export * from "./unit_rating.vue?vue&type=script&lang=js&"
import style0 from "./unit_rating.vue?vue&type=style&index=0&id=71c9feb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c9feb6",
  null
  
)

export default component.exports